import { useQuery } from '@tanstack/react-query';
import api from '../utils/axios.ts';

export interface PlanDuration {
  duration_key: string;
  months: number;
  percentage_discount?: number;
}

export const usePlanDurations = () => {
  const token = typeof window !== 'undefined' ? localStorage.getItem('userToken') : null;
  const { data, isLoading, error } = useQuery({
    queryKey: ['plan-durations'],
    queryFn: async () => {
      const res = await api.get('/plans/durations');
      return (res.data?.data as PlanDuration[]) || [];
    },
    enabled: !!token, // require auth to avoid 404 from protected route
    staleTime: 60 * 60 * 1000,
  });

  return { durations: data || [], isLoading, error };
};


